import { render, staticRenderFns } from "./delete-occupy.vue?vue&type=template&id=97e451b4&"
import script from "./delete-occupy.vue?vue&type=script&lang=ts&"
export * from "./delete-occupy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports